import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/AncillaryRateFactorSets'
import connectIndex from '../../lib/connectIndex'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'

export class AncillaryRateFactorSetIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    records: PropTypes.array,
    pagination: PropTypes.object,
    flashMessages: PropTypes.array.isRequired,
    filterActions: PropTypes.object,
    configuration: PropTypes.object,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    searchColumns: ['vericred_id', 'issuer_id']
  }

  // eslint-disable-next-line react/sort-comp
  static showLinkDisplay = (record) => {
    return <Link title={record.vericred_id} to={`/ancillary_rate_factor_sets/${record.id}`}>{record.vericred_id}</Link>
  }

  // Configure the columns to show as well as whether or not they are filterable or sortable
  static columns = [
    {
      key: 'vericred_id',
      label: 'Rate Factor Set ID',
      display: AncillaryRateFactorSetIndex.showLinkDisplay,
      filterable: false,
      sortable: false
    },
    {
      key: 'name',
      label: 'Name',
      filterable: false,
      sortable: false
    },
    {
      key: 'line_of_coverage',
      label: 'Line of Coverage',
      filterable: true,
      sortable: true
    },
    {
      key: 'issuer_id',
      label: 'Issuer',
      filterable: false,
      sortable: false
    },
    {
      key: 'updated_at',
      label: 'Last Updated At',
      display: IndexComponent.dateTimeDisplay,
      filterable: false,
      sortable: true
    },
    {
      key: 'publish_state',
      label: 'Publish Status',
      display: publishStateDisplayWithModal,
      filterable: true,
      recordLabel: 'text',
      recordValue: 'value'
    },
    {
      label: 'Attached Plans',
      display: AncillaryRateFactorSetIndex.showPlansLinkDisplay,
      filterable: false,
      sortable: false
    }
  ]

  static showPlansLinkDisplay = (record) => {
    const coverageLink = record.line_of_coverage.toLowerCase().replaceAll(' ', '_')
    return (
      <Link
        title="View Plans"
        to={`${coverageLink}_benefits/?search_term=rate_factor_set_id%3A%20${record.vericred_id}`}
      >View Plans
      </Link>
    )
  }

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/ancillary_rate_factor_sets"
          name="Ancillary Rate Factor Sets"
          pagination={this.props.pagination}
          columns={AncillaryRateFactorSetIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          filterActions={this.props.filterActions}
          searchPlaceholder="Search by Rate Factor ID, Issuer"
          filterable
          actions={[]}
          searchColumns={this.props.searchColumns}
          configuration={this.props.configuration}
          newRecordLinkTitle="New Rate Factor Set"
          history={this.props.history}
        />
      </div>
    )
  }
}

// Our filterable columns must know the available values on which to filter.
// This is a hard-coded list from the config, but they can also use a remote select
// to search for available options
const filters = [
  {
    key: 'line_of_coverage',
    config: 'ancillary_rate_factor_sets.line_of_coverage'
  }
]

// wire up our index component with the custom connectIndex that
// links up our filters and actions
export default connectIndex(
  withRouter(AncillaryRateFactorSetIndex),
  'ancillaryRateFactorSets',
  actions,
  filters
)
